import { Component, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatasService, Supports } from '@polylearn/models';
import { environment } from 'apps/landing/src/environments/environment';

@Component({
  selector: 'admin-correct-support',
  template: `
    <button (click)="isShow = !isShow">
      {{ isShow ? 'Hide' : 'Show' }}
    </button>

    <div *ngIf="isShow">
      <div>
        <form>
          <textarea
            (ngModelChange)="
              onSubmit('supports', support.id, 'instructions', $event)
            "
            name="instructions"
            rows="5"
            [(ngModel)]="support.instructions"
          ></textarea>
        </form>
      </div>

      <ul>
        <li *ngFor="let q of support.questions">
          <form>
            <textarea
              (ngModelChange)="onSubmit('questions', q.id, 'text', $event)"
              [name]="'question' + q.id"
              rows="4"
              [(ngModel)]="q.text"
            ></textarea>
          </form>

          <ul>
            <li *ngFor="let c of q.choices">
              <form>
                <textarea
                  (ngModelChange)="onSubmit('choices', c.id, 'text', $event)"
                  [name]="'question' + i + 'choice' + c.id"
                  rows="3"
                  [(ngModel)]="c.text"
                ></textarea>
                <input
                  (ngModelChange)="
                    onSubmit('choices', c.id, 'is_correct', $event)
                  "
                  [name]="'question' + i + 'choice' + c.id + 'is_correct'"
                  type="checkbox"
                  [(ngModel)]="c.is_correct"
                />
                Is correct
              </form>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  `,
  styles: [
    `
      button {
        position: fixed;
        right: 0;
        top: 170px;
        display: block;
      }
    `
  ]
})
export class AdminCorrectSupport {
  @Input() support: Supports;

  isShow = false;

  constructor(private datasService: DatasService) {}

  onSubmit(
    type: 'supports' | 'questions' | 'choices',
    id: number,
    keyValue: string,
    value: string
  ) {
    let data = {};
    data[keyValue] = value;

    console.log('Submit', type, id, value);
    this.datasService
      .updateData$(type as any, 'limitedAdmin', id, data, 'id')
      .subscribe(
        () => {
          console.log('Updated');
        },
        err => {
          window.alert('Error' + err);
        }
      );
  }
}
